import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { LinkGitlabAppInput } from '~/schemas/gitIntegrationsSchemas';
import { githubAppService } from '~/services/userAPI';
import { getTaskPackageQueryKey } from '../activity';

export enum LinkGitlabSourceMutationErrors {
  SET_GITLAB_REPO_ERROR = 'SET_GITLAB_REPO_ERROR',
}

export const useLinkGitlabSourceMutation = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation(
    async (input: LinkGitlabAppInput) => {
      const response = await githubAppService.setGitlabAppRepo({
        ...input,
      });

      if (!response.ok) {
        dispatch({
          type: LinkGitlabSourceMutationErrors.SET_GITLAB_REPO_ERROR,
          error: response.data as string,
        });
        throw new Error(response.problem);
      }

      return response.data;
    },
    {
      onSuccess: (_, { robotId }) => {
        queryClient.invalidateQueries(getTaskPackageQueryKey(robotId));
      },
    },
  );
};
